import React from 'react';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import RepaymentYear from '../../components/RepaymentYear';
import {ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import {postRefinance} from './api';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import RefinanceAssumptionContent from './AssumptionBoxContent/RefinanceAssumptionContent';
//const currentInterestRate = I18n.t('calculators.interest_matrix.live.regular.payg_variable')[0];
const currentInterestRate = '7.40'

class RefinanceCalculator extends React.Component {
  state = {
    type: 'own_home',
    currentLoanAmount: 500000,
    remainingLoanTerm: 30,
    otherMonthlyFees: 0,
    errors: {},
    currentInterestRate,
    rates: {
      liveIn: I18n.t('calculators.interest_matrix.live.special.variable')[0],
      liveInComparison: I18n.t('calculators.interest_matrix.live.special.variable')[1],
      invest: I18n.t('calculators.interest_matrix.invest.regular.variable')[0],
      investComparison: I18n.t('calculators.interest_matrix.invest.regular.variable')[1],
    },
    results: {
      futureLifetimeSavingsOverTermLabel: 0,
      futureInterestRate: 0,
      futureInterestRateLabel: 0,
      futureLifetimeSavingsOverTerm: 0,
      futurePaymentPerMonth: 0,
      futurePaymentPerMonthLabel: 0,
      futurePotentialMonthlySavings: 0,
      futurePotentialMonthlySavingsLabel: 0,
    }
  };
  onCalculationSuccess = (response) => {
    this.setState({results: response.data})
  };

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors;

    let swalTitle = I18n.t('calculators.generic_error.title');
    let swalText = I18n.t('calculators.generic_error.description');

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title');
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  };

  onCalculationSubmit = () => {
    let data = {
      refinance: {...this.state, currentInterestRate: this.state.currentInterestRate * 0.01}
    };
    delete data.refinance.results
    postRefinance(
      data,
      this.onCalculationSuccess,
      this.onCalculationFailure
    )
  };
  
  expandingLead = (
    <p>The refinance calculator lets you do a mortgage comparison and estimate your savings if you are to switch over to Yard loan.</p>
  );
  
  expandingInfoContent = (
    <p>The mortgage refinance calculator will show you the reduction in monthly repayment and the amount of interest you will save over the life of the loan. To get started, enter your current loan amount, interest rate & other monthly fees and the remaining loan term.</p>
  );
  
  calculatorForm() {
    const {currentLoanAmount, remainingLoanTerm, currentInterestRate, otherMonthlyFees, errors} = this.state;
    return (
      <div>
        <div className="refinance-calculator__loan-target-toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                            type="radio"
                            name="options"
                            defaultValue={'own_home'}
                            onChange={ (value) => { this.setState({ type: value }) } }>
            <ToggleButton className='btn onboarding-form' value="own_home">I will live there</ToggleButton>
            <ToggleButton className='btn onboarding-form' value="investment">I am investing</ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className="numeric-input">
          <InputWithLabel
            label='Current loan amount'
            type='currency'
            defaultValue={currentLoanAmount}
            errorMessage={errors['currentLoanAmount']}
            onChange={(value) => this.setState({currentLoanAmount: value})}
          />
        </div>
        <RepaymentYear
          label='Loan term (years)'
          defaultValue={remainingLoanTerm}
          onChange={(value) => this.setState({remainingLoanTerm: value})}
        />
        <div className="rate-input">
          <InputWithLabel
            label='Current interest rate'
            type='append'
            appendText={ '%' }
            defaultValue={currentInterestRate}
            errorMessage={errors['currentInterestRate']}
            onChange={(value) => this.setState({currentInterestRate: value})}
          />
        </div>
        <div className="numeric-input">
          <InputWithLabel
            label='Other monthly fees'
            type='currency'
            defaultValue={otherMonthlyFees}
            errorMessage={errors['otherMonthlyFees']}
            onChange={(value) => this.setState({otherMonthlyFees: value})}
          />
        </div>
      </div>
    );
  }

  resultsColumn() {
    const {futureLifetimeSavingsOverTermLabel, futurePotentialMonthlySavingsLabel, futurePaymentPerMonthLabel} = this.state.results;
    return <React.Fragment>
      <div className="calculator-result-card-set">
        <CalculatorResultCard
          caption='Your savings with a Yard P&I Variable Interest Rate loan*'
          figure={futurePotentialMonthlySavingsLabel}
          figureText='per month'
        />
        <CalculatorResultCard
          caption='New payment'
          figure={futurePaymentPerMonthLabel}
          figureText='per month'
        />
        <CalculatorResultCard
          caption='Loan lifetime saving over the remaining term'
          figure={futureLifetimeSavingsOverTermLabel}
        />
      </div>
      <CalculatorCallToActionCard>
        <div className='refinance-calculator__cta'>
          <p className='ready-to-refinance'>Ready to refinance?</p>
        </div>
      </CalculatorCallToActionCard>
    </React.Fragment>;
  }
  
  render() {
    return (
      <div className="refinance-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo lead={this.expandingLead}>{this.expandingInfoContent}</ExpandingInfo>}
          formColumn={
            <CalculatorForm handleSubmit={this.onCalculationSubmit}>{this.calculatorForm()}</CalculatorForm>
          }
          resultsColumn={this.resultsColumn()}  
        >
          <CalculatorAssumptions assumptionBoxContents={<RefinanceAssumptionContent />} />
        </CalculatorLayout>
      </div>
    );
  }
}

export default RefinanceCalculator;
